

















































import Vue from 'vue'
import ShopsForm from '../components/ShopsForm.vue'
import { createShop } from '../services/shops-client'
import { ShopCreateData } from '../types'
import { fetchCurrenciesList } from '@morpheus/currency/admin-vue/services/currencies-client'
import { CurrenciesListData } from '@morpheus/currency/admin-vue/types'

export default Vue.extend({
  name: 'ShopsCreate',
  components: {
    ShopsForm
  },
  data () {
    return {
      isLoading: false,
      clearForm: false,
      currenciesList: {},
      currenciesListArray: [] as Array<any>
    }
  },
  mounted () {
    fetchCurrenciesList()
      .then((currenciesList: CurrenciesListData) => {
        this.currenciesList = currenciesList
        Object.keys(this.currenciesList).map(key => {
          this.currenciesListArray.push({ 'text': key, 'value': key })
        })
      })
      .catch(error => {
        this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
      })
      .finally(() => {
        this.isLoading = false
        this.$store.commit('global/setLoading', false)
      })
  },
  methods: {
    onSubmit (shop: ShopCreateData) {
      this.isLoading = true
      createShop(shop)
        .then(() => {
          this.clearForm = true
          this.$store.commit('global/addNotification', {
            text: 'You successfully created new shop!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onClearForm () {
      this.clearForm = false
    }
  }
})
